var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.159205 0.550859C0.371403 0.338767 0.715358 0.338852 0.927451 0.55105L11.8355 11.4646C12.0476 11.6768 12.0476 12.0207 11.8354 12.2328C11.6232 12.4449 11.2792 12.4448 11.0671 12.2326L0.159013 1.3191C-0.0530791 1.10691 -0.0529935 0.762951 0.159205 0.550859Z",
    fill: "#FFAB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8354 0.550859C12.0476 0.762951 12.0476 1.10691 11.8355 1.3191L0.927451 12.2326C0.715358 12.4448 0.371403 12.4449 0.159205 12.2328C-0.0529935 12.0207 -0.0530791 11.6768 0.159013 11.4646L11.0671 0.55105C11.2792 0.338852 11.6232 0.338767 11.8354 0.550859Z",
    fill: "#FFAB00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopOrange);
export default __webpack_public_path__ + "static/media/stop_orange.4241962e0dddc24475d1b7218b8f6def.svg";
export { ForwardRef as ReactComponent };